<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({ name: "UiDateRangePicker" });
</script>
<template>
    <!-- * 时间范围选择器 -->
    <div class="ui-date-range-picker" ref="container" v-bind="binds.container">
        <!-- * 选择器主体 -->
        <div class="ui-form-control" @click="show">
            <input class="ui-date-range-context" type="text" aria-name="start" v-bind="binds.start" readonly />
            <div class="ui-date-range-rect"></div>
            <input class="ui-date-range-context" type="text" aria-name="end" v-bind="binds.end" readonly />
        </div>

        <!-- * 候选列表 -->
        <Transition v-on="ons.candidates">
            <div class="ui-form-candidates" ref="candidates" v-if="visible" v-bind="binds.candidates">
                <div class="ui-form-candidate-container">
                    <component ref="components" :is="view" :confirm="confirm" v-on="ons.components"></component>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script lang="ts" setup>
//* Vue
import { onBeforeUnmount } from "vue";
//* 组件属性
import { UiDateRangePickerPropsOption, UiDateRangePickerEmits } from "./src/component";
import { useComposable } from "./src/composable";

//* 组件属性注册
const emits = defineEmits(UiDateRangePickerEmits);
const define = defineProps(UiDateRangePickerPropsOption);

//* 组合函数
const { ons, vars, refs, nodes, binds, watchs, methods, computeds } = useComposable(define, emits);
const { view } = computeds;
const { show } = methods;
const { candidates, components, container } = nodes;
const { visible } = refs;

//* 组件卸载时释放内存
onBeforeUnmount(() => {
    watchs?.stop_watch();
    vars.observer?.disconnect();
});

//* 初始化组件配置
;
</script>
